// React
import React from "react";
// Components
import DataBar from "common/ui/components/dataBar/DataBar";
import DataBarItem from "common/ui/components/dataBar/DataBarItem";
import GraphDoubleAxis from "common/ui/components/graphs/GraphDoubleAxis";
import StatsCard from "common/ui/containers/cards/StatsCard";
// Utils
import * as utils from "office/reports/stats/utils/utils";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ListingAverageLeads extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { listingType, charts, fromDate, toDate } = this.props;
        // Merge the three series into one
        let series = [];
        let index = 1; //listingType + 1;
        for (let i = 0; i < charts.avgStandardLeadsGraph.series.length; i++) {
            let dataArray = [];
            dataArray.push(charts.avgStandardLeadsGraph.series[i][0]);
            dataArray.push(charts.avgStandardLeadsGraph.series[i][index]);
            dataArray.push(charts.avgFeaturedLeadsGraph.series[i][index]);
            dataArray.push(charts.avgHdLeadsGraph.series[i][index]);
            dataArray.push(charts.avgFeaturedHdLeadsGraph.series[i][index]);
            dataArray.push(charts.listingsCountGraph.series[i][index]);
            series.push(dataArray);
        }
        let seriesLabels = [
            utils.avgListingTypeStandardGraphLabels[listingType],
            utils.avgListingTypeFeaturedGraphLabels[listingType],
            utils.avgListingTypeHdGraphLabels[listingType],
            utils.avgListingTypeFeaturedHdGraphLabels[listingType],
            utils.totalListingTypeLabels[listingType]
        ];
        const colors = [
            charts.avgStandardLeadsGraph.colour,
            utils._colourFeatured,
            utils._colourHd,
            utils._colourFeaturedHd,
            charts.avgStandardLeadsGraph.colour
        ];
        //-- Return
        return (React.createElement(StatsCard, null,
            React.createElement(DataBar, { label: utils.avgListingTypeLeadsLabels[listingType], labelTooltip: "Average Listing Lead performance in the given date range." },
                React.createElement(DataBarItem, { description: utils.avgListingTypeStandardLeadLabels[listingType], toolTip: "Average Leads for all Standard Listings in the given date range", value: charts.avgStandardLeadsGraph.summaryValue }),
                React.createElement(DataBarItem, { description: utils.avgListingTypeFeaturedLeadLabels[listingType], toolTip: "Average Leads for all Featured Listings in the given date range", value: charts.avgFeaturedLeadsGraph.summaryValue }),
                React.createElement(DataBarItem, { description: utils.avgListingTypeHdLeadLabels[listingType], toolTip: "Average Leads for all HD Listings in the given date range", value: charts.avgHdLeadsGraph.summaryValue }),
                React.createElement(DataBarItem, { description: utils.avgListingTypeFeaturedHdLeadLabels[listingType], toolTip: "Average Leads for all HD Listings that are also Featured in the given date range", value: charts.avgFeaturedHdLeadsGraph.summaryValue })),
            React.createElement(GraphDoubleAxis, { title: "Average Leads per day", xAxis: "Days", yAxis: "Average Leads", fromDate: fromDate, toDate: toDate, series: series, seriesColours: colors, seriesLabels: seriesLabels, vAxis1ValuesVisible: false })));
    }
}
